module.exports = __webpack_public_path__ + "2d31637878336857efdcd32383f7a32f.png";